var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { persistentKVStore } from '../persistence';
var overridesStorageKey = 'squireFlagOverrides';
export var getFlagOverrides = function () {
    var _a;
    var jsonString = (_a = persistentKVStore.getItem(overridesStorageKey)) !== null && _a !== void 0 ? _a : '{}';
    try {
        return JSON.parse(jsonString);
    }
    catch (err) {
        return {};
    }
};
export var setFlagOverride = function (key, value) {
    var _a;
    var overrides = getFlagOverrides();
    var newOverrides = __assign(__assign({}, overrides), (_a = {}, _a[key] = value, _a));
    persistentKVStore.setItem(overridesStorageKey, JSON.stringify(newOverrides));
};
export var resetFlagOverride = function (key) {
    var overrides = getFlagOverrides();
    if (key in overrides) {
        delete overrides[key];
    }
    persistentKVStore.setItem(overridesStorageKey, JSON.stringify(overrides));
};
export var resetFlagOverrides = function () {
    persistentKVStore.setItem(overridesStorageKey, JSON.stringify({}));
};
export var mergeWithOverrides = function (flags, overrides) {
    return Object.keys(flags).reduce(function (memo, key) {
        var _a;
        var value = flags[key];
        if (typeof overrides[key] === 'boolean') {
            value = overrides[key];
        }
        return __assign(__assign({}, memo), (_a = {}, _a[key] = value, _a));
    }, {});
};
export var buildContext = function (options) {
    var platformContext = {
        kind: 'platform',
        key: 'commander',
    };
    if ((options === null || options === void 0 ? void 0 : options.brandId) && (options === null || options === void 0 ? void 0 : options.shopId) && (options === null || options === void 0 ? void 0 : options.barberId)) {
        return {
            kind: 'multi',
            brand: { kind: 'brand', key: options.brandId },
            shop: { kind: 'shop', key: options.shopId },
            barber: { kind: 'barber', key: options.barberId },
            platform: platformContext,
        };
    }
    if ((options === null || options === void 0 ? void 0 : options.brandId) && (options === null || options === void 0 ? void 0 : options.shopId)) {
        return {
            kind: 'multi',
            brand: { kind: 'brand', key: options.brandId },
            shop: { kind: 'shop', key: options.shopId },
            platform: platformContext,
        };
    }
    if (options === null || options === void 0 ? void 0 : options.brandId) {
        return {
            kind: 'multi',
            brand: { kind: 'brand', key: options.brandId },
            platform: platformContext,
        };
    }
    return {
        kind: 'multi',
        user: {
            kind: 'user',
            key: 'anonymous',
            anonymous: true,
        },
        platform: platformContext,
    };
};
